import moment from 'moment';
import React from 'react';
import { LOCALES, LOCALES_DOUBLE } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { formatDate } from 'src/utils/helpers';
import ReactCalendar from 'src/view/components/ReactCalendar/ReactCalendar';
import { defaultDate } from '~/constants/dateTime';
import './style.scss';

enum WEEK_MODAL_ACTIVE_DAY {
  START,
  END,
}

interface IProps {
  start_date?: Date | null;
  end_date?: Date | null;
  changeDate: (date: { start_date: Date | undefined; end_date: Date | undefined }) => void;
}

interface IState {
  start_date: string | null | undefined;
  end_date: string | null | undefined;
  activeDay: WEEK_MODAL_ACTIVE_DAY;
}

export default class WeekModalCalendar extends React.Component<IProps, IState> {
  state: IState = {
    start_date: formatDate(this.props.start_date) || defaultDate,
    end_date: formatDate(this.props.end_date) || defaultDate,
    activeDay: WEEK_MODAL_ACTIVE_DAY.START,
  };

  changeDate = (data: [Date] | [Date, Date]) => {
    if (!data) return;
    const [start_date, end_date] = [data[0], data[1]];
    this.setState({ start_date: formatDate(start_date), end_date: formatDate(end_date) });
    this.props.changeDate({ start_date, end_date });
  };

  clickDay = (date: Date) => {
    if (this.state.activeDay === WEEK_MODAL_ACTIVE_DAY.START) {
      this.setState({ start_date: formatDate(date), activeDay: WEEK_MODAL_ACTIVE_DAY.END });
      this.props.changeDate({ end_date: this.state.end_date !== defaultDate ? moment(this.state.end_date).toDate() : undefined, start_date: date });
    } else {
      this.setState({ end_date: formatDate(date), activeDay: WEEK_MODAL_ACTIVE_DAY.START });
      this.props.changeDate({
        start_date: this.state.start_date !== defaultDate ? moment(this.state.start_date).toDate() : undefined,
        end_date: date,
      });
    }
  };

  render() {
    return (
      <div className="week-modal-calendar__container d-flex flex-column">
        <div className="d-flex flex-row justify-content-between mx-8 mb-4">
          <div
            className={`d-flex flex-column align-items-center ${this.state.activeDay === WEEK_MODAL_ACTIVE_DAY.START ? 'color-gray2' : 'color-dark'}`}
          >
            <h2 className="family-medium text-size-12 text-uppercase letter-spacing-12">{localeStore.t('start_date')}</h2>
            <p className="family-semibold text-size-18 mt-1">{this.state.start_date}</p>
          </div>
          <div
            className={`d-flex flex-column align-items-center ${this.state.activeDay === WEEK_MODAL_ACTIVE_DAY.END ? 'color-gray2' : 'color-dark'}`}
          >
            <h2 className="family-medium text-size-12 text-uppercase letter-spacing-12">{localeStore.t('end_date')}</h2>
            <p className="family-semibold text-size-18 mt-1">{this.state.end_date}</p>
          </div>
        </div>
        <ReactCalendar
          maxDate={undefined}
          minDate={new Date()}
          locale={localeStore.language === LOCALES.EN ? LOCALES_DOUBLE.en : LOCALES_DOUBLE.ar}
          selectRange={true}
          onChange={this.changeDate}
          onClickDay={this.clickDay}
          minDetail="decade"
          value={[moment(this.props.start_date).toDate(), moment(this.props.end_date).toDate()]}
          formatMonth={(locale, date) => moment(date).format('MMM')}
          formatShortWeekday={(locale, date) => moment(date).format('dd')}
        />
      </div>
    );
  }
}
